import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type AlertDeliveryFull = Pick<
  Types.AlertDelivery,
  'dispatchedAt' | 'label' | 'message' | 'outputId' | 'statusCode' | 'success' | 'url'
>;

export const AlertDeliveryFull = gql`
  fragment AlertDeliveryFull on AlertDelivery {
    dispatchedAt
    label
    message
    outputId
    statusCode
    success
    url
  }
`;
